import fetch from '@/utils/fetch'

export function getAddressList () {
  return fetch({
    url: '/comm/shippingAddress/list',
    method: 'post'
  })
}

export function saveObj (data) {
  let url = '/comm/shippingAddress/save'
  if (data.id) {
    url = '/comm/shippingAddress/update'
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}
export function deleteObj (id) {
  return fetch({
    url: `/comm/shippingAddress/delete/${id}`,
    method: 'post'
  })
}
